import React from 'react';
import { Link } from 'gatsby';
import styled from 'styled-components';
import { naviListData } from '../data';

export default () => {
  let pathname = '';
  if (typeof window !== `undefined`) pathname = location.pathname;
  const isNowEng = pathname.indexOf('/eng/') !== -1;
  const langauageType = isNowEng ? 'eng' : 'ja';
  const toJaLink = isNowEng ? pathname.replace('/eng/', '') : pathname;
  const toEngLink = isNowEng ? pathname : `/eng${pathname}`;
  const naviList = naviListData.filter((item) => item.type === langauageType);
  return (
    <nav role="navigation">
      <Wrap>
        <Text to="/">ぴんとくるくる浄土</Text>
        <NavListWrap>
          {naviList.map((item) => (
            <NavListItem>
              <Link to={item.link}>{item.name}</Link>
            </NavListItem>
          ))}
        </NavListWrap>
        {/* <div>
          <Langauge to={toJaLink} className={pathname}>
            Ja
          </Langauge>
          <span>/</span>
          <Langauge to={toEngLink} className={pathname}>
            En
          </Langauge>
        </div> */}
      </Wrap>
    </nav>
  );
};

const Wrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 1.25em;
`;

const Text = styled(Link)`
  text-decoration: none;
`;

const Langauge = styled(Link)`
  padding-left: 10px;
  padding-right: 10px;
  opacity: ${(props) => (props.to === props.className ? 1.0 : 0.3)};
`;

const NavListWrap = styled.ul`
  display: flex;
  justify-content: center;
  list-style: none;
  padding: 0;
  margin: 0;
  height: 20vh;
  max-height: 100px;
  font-size: 1.25em;
`;

const NavListItem = styled.li`
  display: inline-flex;
  align-items: center;
  margin: 0 1em;
  a {
    color: currentColor;
  }
`;
